export default __webpack_public_path__ + "static/media/login_background.44436ec8.png";